import { render, staticRenderFns } from "./classifyAddSave.vue?vue&type=template&id=7564396e&"
import script from "./classifyAddSave.vue?vue&type=script&lang=js&"
export * from "./classifyAddSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports